import { observer } from 'mobx-react';
import { FC, useCallback } from 'react';
import configWebStore from '../../stores';
import { LOCALES } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import MultiLanguageInput from 'src/view/components/Controls/MultiLanguageInput/MultiLanguageInput';
import MultiLanguageTextArea from 'src/view/components/Controls/MultiLanguageTextArea/MultiLanguageTextArea';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import { TBooleanInNumber } from '~/types/main';
import { booleanToNumber } from '~/utils/helpers';

const WebConfigMetaBlock: FC = observer((): JSX.Element => {
  const changeKeyword = useCallback(
    (text: string, locales: LOCALES) => {
      configWebStore.changeConfigMetaDetails({
        keyword: { ...configWebStore.configuration.metaDetails.keyword, [locales]: text },
      });
    },
    [configWebStore.configuration.metaDetails.keyword]
  );

  const changeIsHumanReadableUrl = useCallback((value: TBooleanInNumber) => {
    configWebStore.changeIsHumanReadableUrl(value);
  }, []);

  const changeDescription = useCallback(
    (text: string, locales: LOCALES) => {
      configWebStore.changeConfigMetaDetails({
        description: { ...configWebStore.configuration.metaDetails.description, [locales]: text },
      });
    },
    [configWebStore.configuration.metaDetails.description]
  );

  return (
    <div className="d-flex flex-column gap-15">
      <Text type={TEXT.SECTION_HEADER} text="meta_details" className="mt-6" />

      <div className="web-config-meta-block mt-1">
        <Text type={TEXT.ORDER_FIELD} text="keyword" className="web-config-meta-block__title" />
        <MultiLanguageInput
          enText={configWebStore.configuration.metaDetails.keyword.en}
          arText={configWebStore.configuration.metaDetails.keyword.ar}
          onChangeValue={changeKeyword}
          placeholder={localeStore.t('Value')}
          className="web-config-meta-block__input"
        />
      </div>

      <MultiLanguageTextArea
        title="description"
        enText={configWebStore.configuration.metaDetails.description.en}
        arText={configWebStore.configuration.metaDetails.description.ar}
        onChangeValue={changeDescription}
        placeholder={localeStore.t('Value')}
        className="web-config-meta-block__text-area"
        textAreaClassName="web-config-meta-block__text-area-input"
        headerClassName="web-config-meta-block__text-area-header pr-1"
        titleClassName="web-config-meta-block__text-area-title"
      />

      <div className="d-flex align-items-center">
        <Switcher status={booleanToNumber(configWebStore.configuration.is_human_readable_url)} onChange={changeIsHumanReadableUrl} />
        <Text type={TEXT.SWITCHER_LABEL} text={localeStore.t('oc_config_seo_optimized_links_toggle')} className="text-nowrap" />
      </div>
    </div>
  );
});

export default WebConfigMetaBlock;
